export * from './header/header.component';
export * from './sidebar/sidebar.component';



// WEBPACK FOOTER //
// ./src/app/shared/components/index.ts